import DatePicker from 'react-datepicker'; // own

import "./DatePicker.css";
export default DatePicker;